import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import loginConfig from 'auth/loginConfig';
import signUpConfig from 'auth/signUpConfig';
import styles from './HeroSection.module.less';
import heroOmni from 'assets/img/omnione_getstarted_hero.png';

export default function HeroSection() {
	const { loginWithRedirect, user } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.heroSectionBackground}>
				<div className={styles.heroSectionContainer}>
					<div className={styles.heroSectionTextCol}>
						<div className={styles.heroSectionTextWrapper}>
							<h1 className={styles.heroSectionHeader}>Welcome to Omni Dev</h1>
							<p className={styles.heroSectionSubHeader}>
								Omni Dev is your portal to manage your Omni One projects and
								access SDKs, documentation, and other downloads.
							</p>
							<div className={styles.heroSectionBtns}>
								{!user && (
									<>
										<div onClick={() => loginWithRedirect(loginConfig)}>
											<div className={styles.heroSectionBtnLight}>
												{t('common.login')}
											</div>
										</div>
										<div onClick={() => loginWithRedirect(signUpConfig)}>
											<div className={styles.heroSectionBtn}>
												{t('common.SignUp')}
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
					<div className={styles.heroSectionImageCol}>
						<div className={styles.heroSectionImageWrapper}>
							<img
								src={heroOmni}
								alt="Omni One"
								className={styles.heroSectionImage}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.heroSectionImageResponsive}></div>
		</>
	);
}
